// Keep only local job references so a later successful start can measure recovery.
const key = uid => `instanttranscriber_quota_resume_v1:${uid}`;
function records(uid) {
  if (!uid) return {};
  try {
    const data = JSON.parse(localStorage.getItem(key(uid)) || '{}');
    return Object.fromEntries(Object.entries(data).filter(([,expires]) => Number.isFinite(expires) && expires > Date.now()).slice(-10));
  } catch { return {}; }
}
export function rememberQuotaBlocked(uid, id) {
  if (!uid || !id) return;
  try { localStorage.setItem(key(uid), JSON.stringify({ ...records(uid), [id]: Date.now() + 7 * 86400000 })); } catch {}
}
export function consumeQuotaRecovery(uid, id) {
  const data = records(uid);
  if (!data[id]) return false;
  delete data[id];
  try { localStorage.setItem(key(uid), JSON.stringify(data)); } catch {}
  return true;
}
